import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=72f5ea18&"
import script from "./PageLayout.vue?vue&type=script&lang=js&"
export * from "./PageLayout.vue?vue&type=script&lang=js&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=72f5ea18&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f5ea18')) {
      api.createRecord('72f5ea18', component.options)
    } else {
      api.reload('72f5ea18', component.options)
    }
    module.hot.accept("./PageLayout.vue?vue&type=template&id=72f5ea18&", function () {
      api.rerender('72f5ea18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/PageLayout.vue"
export default component.exports